import { createIcon } from '@chakra-ui/react';

export const SearchIcon = createIcon({
  displayName: 'SearchIcon',
  viewBox: '0 0 32 32',
  defaultProps: {
    fill: 'none',
    height: '32',
    width: '32',
  },
  path: (
    <>
      <path
        d="M28 0.5C29.933 0.5 31.5 2.067 31.5 4V28C31.5 29.933 29.933 31.5 28 31.5H0.5V0.5H28Z"
        fill="#EDF2F7"
      />
      <path
        d="M28 0.5C29.933 0.5 31.5 2.067 31.5 4V28C31.5 29.933 29.933 31.5 28 31.5H0.5V0.5H28Z"
        stroke="#E2E8F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7375 20.6375L19.4038 17.2863C20.0381 16.4012 20.3779 15.3389 20.375 14.25C20.375 11.3537 18.0213 9 15.125 9C12.2288 9 9.875 11.3537 9.875 14.25C9.875 17.1462 12.2288 19.5 15.125 19.5C16.2625 19.5 17.295 19.1413 18.1613 18.5288L21.5125 21.8625C21.6788 22.0375 21.9063 22.125 22.125 22.125C22.3438 22.125 22.58 22.0462 22.7375 21.8625C22.8186 21.7816 22.883 21.6854 22.9269 21.5795C22.9708 21.4737 22.9934 21.3602 22.9934 21.2456C22.9934 21.131 22.9708 21.0176 22.9269 20.9117C22.883 20.8059 22.8186 20.7097 22.7375 20.6287V20.6375ZM15.125 18.3625C12.8588 18.3625 11.0125 16.5163 11.0125 14.25C11.0125 11.9838 12.8588 10.1375 15.125 10.1375C17.3913 10.1375 19.2375 11.9838 19.2375 14.25C19.2375 16.5163 17.3913 18.3625 15.125 18.3625Z"
        fill="black"
      />
    </>
  ),
});
